import React from "react";
import QuicksearchOption from "./QuicksearchOption";
class QuickSearch extends React.Component { 
  render() {
    const {mealtypeData}=this.props;
    return (
       <div>
        <div className="quickSearch1">
            <p className="Head1">Quick Search</p>
            <br/>
          <h1 className="Head2">Discover restaurants by type of meal</h1>
        </div>
        <div className="container-fluid">
         {mealtypeData.map((item)=>{ 
               return  <QuicksearchOption quicksearchitemData={item}/>
           })} 
      </div>
     </div>
    );
   }
 }

 export default QuickSearch;

